module.exports = __webpack_public_path__ + "static/media/04.Felicitation from K.K.Pai - Bhaskar Kogga Kamath.e971b1da.jpg";